const densityUnitsEnum = Object.freeze({
    POUNDS_PER_BUSHEL: 0,
    KG_PER_BUSHEL: 1,
    POUNDS_PER_M3: 2,
    KG_PER_M3: 3,
})

export default densityUnitsEnum